<template>
  <div class="sub-form-container">
		<div class="sub-container" v-if="!formSubmitted">
			<div class="sub-inputtext">
				<p>{{ subscriptionTemplate.label[language] }}</p>
				<input :class="{'error-input': error}" type="email" :placeholder="subscriptionTemplate.placeholder[language]" v-model="email" @change="error = false"/>
				<div class="sub-consent">
					<label class="checkbox">
						<input type="checkbox" v-model="consent" id="consent" />
						<span class="sub-consent"  :class="{'error-consent': consentError}">{{ subscriptionTemplate.consent[language] }}</span>
					</label>
					<!-- <input type="checkbox" v-model="consent" id="consent">
					<label for="consent" class="sub-consent" :class="{'error-consent': consentError}">{{ subscriptionTemplate.consent[language] }}</label> -->
				</div>
				<div class="error-msg" v-if="error">{{ subscriptionTemplate.error_msg[language] }}</div>
			</div>
			<button type="button" class="sub-button-submit" @click="validateForm">
				<span v-if="!formProcessing">
					{{ subscriptionTemplate.button_text[language] }}
				</span>
				<fa-icon v-show="formProcessing" icon="circle-notch" spin />
			</button>
		</div>
		<div class="sub-thank-you" v-if="formSubmitted">{{ subscriptionTemplate.thank_you[language] }}</div>
  </div>
</template>

<script>
import axios from 'axios';
import { mapState, mapGetters } from 'vuex';

export default {
	name: 'SubscriptionView',
	data() {
		return {
			email: '',
			error: false,
			consent: false,
			consentError: false,
			formSubmitted: false,
			formProcessing: false,
		};
	},
	computed: {
		...mapState('staticData', ['generalSettings']),
		...mapGetters('staticData', {
			language: 'getLanguage',
			languageList: 'getLanguageList',
		}),
		subscriptionTemplate() {
			let parsed = {
				label: { [this.language]: 'Set in template!' },
				placeholder: { [this.language]: 'Set in template!' },
				button_text: { [this.language]: 'Set in template!' },
			};
			if (this.generalSettings.subscription_template) {
				parsed = JSON.parse(this.generalSettings.subscription_template);
			}
			return parsed;
		},
	},
	methods: {
		validateForm() {
			const mailformat = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
			if (this.email.match(mailformat) && this.consent) {
				this.submitForm();
			} else if (!this.email.match(mailformat) && !this.consent) {
				this.error = true;
				this.consentError = true;
			} else if (!this.email.match(mailformat)) {
				this.error = true;
				this.consentError = false;
			} else if (!this.consent) {
				this.error = false;
				this.consentError = true;
			}
		},
		submitForm() {
			if (this.formSubmitted && this.formProcessing) return false;
			this.formProcessing = true;
			axios.post('/api/subscribe-api', { email: this.email }).then(() => {
				this.formSubmitted = true;
				this.formProcessing = false;
				this.email = '';
			}).catch(() => {
				this.formProcessing = false;
			});
			return true;
		},
	},
};
</script>

<style src="@/styles/components/SubscriptionView/SubscriptionView.less" lang="less" scoped></style>
